module.exports = {"en":{"modules":{"home":{"title":"Home Screen","tabbarTitle":"Home","call":{"title":"Call"}}}}}